<template>
    <b-overlay :show="loading" class="animated mt-4">
        <h1 v-if="show_title">Quality Controls</h1>
        <modal-trash-basket
            v-if="show_modal"
            :entity_type="entity_type"
            :trash="trash"
            @onUpdate="onUpdate"
        />
        <div class="animated">
            <v-server-table
                :columns="table_config.columns"
                :options="table_config.options"
                :theme="theme"
                :ref="ref"
                @onUpdate="onUpdate"
            >
                <span slot="name" slot-scope="{ row }">
                    <a :href="`#/quality-control/${row.id}`" class="btn-link">{{ row.name }}</a>
                </span>
                <span slot="sample_type" slot-scope="{ row }">
                    {{ row.test_package.sample_type.name }}
                </span>
                <span slot="schedulable_task_type" slot-scope="{ row }">
                    {{formatTaskName(row.schedulable_task_type) }}
                </span>
                <span slot="task" slot-scope="{ row }">
                    {{ row.test_package.name }}
                </span>
                <span slot="actions" slot-scope="{ row }">
                    <b-button
                        v-show="checkPermission('edit quality control')"
                        variant="warning"
                        class="px-1 py-0 text-white mr-1"
                        :to="`/quality-control/${row.id}/edit`"
                    >
                      <i class="fa fa-pencil" />
                    </b-button>

                    <template v-if="checkPermission('delete quality control')">
                        <a
                          v-if="isDeleted(row.id)"
                          class="btn btn-success px-1 py-0 text-white mr-1"
                          @click="restoreFromTrash(row.id)"
                        >
                          <i class="fa fa-refresh" />
                        </a>
                        <a
                          v-else
                          class="btn btn-danger px-1 py-0 text-white mr-1"
                          @click="putToTrash(row)"
                        >
                          <i class="fa fa-trash" />
                        </a>
                    </template>
                </span>
            </v-server-table>
        </div>
    </b-overlay>
</template>

<script>
import Vue from "vue";
import BaseServerTable from "@/components/shared/BaseServerTable";
import { ServerTable } from "vue-tables-2";
import ToastNotifications from "@/components/shared/mixins/ToastNotifications";
import { AccessControlCheck } from "@/auth/AccessControlCheck";
import { formatModelPath, stripTaskFromName } from "@/shared/utils";
import QualityControlCollection from "@/collections/lab/QualityControlCollection";
import { mapActions, mapGetters } from 'vuex';
import ModalTrashBasket from "@/components/shared/ModalTrashBasket";
    
Vue.use(ServerTable)

export default {
    name: "WorkflowQualityControlTable",
    extends: BaseServerTable,
    mixins: [ToastNotifications],
    components: {
        ServerTable,
        ModalTrashBasket
    },
    props: {
        collection: {
            type: Object,
            default: () => new QualityControlCollection()
        },
        sample_id: {
            type: String,
            default: () => ""
        },
        schedulable_task_id: {
            type: String,
            default: null
        },
        schedulable_task_type: {
            type: String,
            default: null
        },
        quality_control: {
            type: Object,
            default: () => null,
        },
        show_columns: {
            type: Array,
            default: () => [
                "name",
                "sheet_label",
                "sample_type",
                "schedulable_task_type",
                "task",
                "interval",
                "interval_index",
                "actions"
            ]
        },
        filterable: {
          type: Array,
          default: () => [],
        },
        sortable: {
          type: Array,
          default: () => [],
        },
        show_filters: {
          type: Boolean,
          default: false,
        },
        show_title: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            entity_type: "qualityControl",
            table_config: Object.assign(this.getDefaultTableConfig(), {
                options: {
                    headings: {
                        schedulable_task_type: "Task type"
                    },
                    filterable: this.filterable,
                    sortable: this.sortable,
                    debounce: 300,
                },
            }),
        };
    },
    computed: {
        ...mapGetters({
            trash: "qualityControlTrash",
        }),
        show_modal() {
            return (
                this.checkPermission("delete quality control") &&
                this.show_columns.includes("actions")
            );
        },
    },
    methods: {
        prepareCollectionFilter(filter) {
            //filter.sortAddDesc("created_at", true);

            if (this.schedulable_task_id) {
                filter.filterEquals("schedulable_task_id", this.schedulable_task_id)
            } else {
                filter.filterEquals("testPackage.sample_type_id", this.sample_id);

                filter.connectionAdd(['testPackage.sampleType']);
            }

            return filter;
        },
        formatTaskName(str) {
            return stripTaskFromName(formatModelPath(str))
        },
        ...mapActions(["PUT_TO_TRASH", "RESTORE_FROM_TRASH"]),
        putToTrash(value) {
            this.PUT_TO_TRASH({ value, name: this.entity_type });
        },
        restoreFromTrash(id) {
            this.RESTORE_FROM_TRASH({ id, name: this.entity_type });
        },
        isDeleted(id) {
            return this.trash.find((item) => item.id === id);
        },
        checkPermission(permission) {
            return AccessControlCheck.checkPermission(permission);
        },
        onUpdate() {
            this.$refs[this.ref].refresh();
        }
    },
};
</script>